var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"font-weight-bold",attrs:{"variant":_vm.getVariant(_vm.status)}},[_vm._v(" "+_vm._s(_vm.getLabel(_vm.status))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }